/**
 * 公用函数
 */
// import axios from 'axios';
// import qs from 'qs';
// import store from '../../store';
import VueCookies from "vue-cookies";



export default {
    /**
     * 登录
     * @param obj
     */
    /*loginSetCookie(obj) {
        this.setCookie('muid', obj.muid);
        this.setCookie('accountid', obj.accountid);
        this.setCookie('token', obj.token);
    },*/
    /**
     * 设置cookie
     * @param name
     * @param value
     * @param expires
     * @param path
     * @param domain
     * @param secure
     */
    /*setCookie(name, value, expires = 8640000, path='/', domain='', secure=false) {
        domain = process.env.VUE_APP_DOMAIN ? process.env.VUE_APP_DOMAIN : '';

        VueCookies.set(name, value, expires, path, domain, secure);
    },*/
    /**
     * 是否登录
     * @returns {boolean}
     */
    isLogin() {
        return VueCookies.get('muid') && VueCookies.get('token');
    },
    compressImg(image, zoom, width, height) {

        let img = image;
        let w = img.width;
        let h = img.height;
        // console.log("w + h : " + w + ' + ' + h)

        if ((width != 0 && w > width) || (height != 0 && h > height)) {
            let scale = Math.min(width / w, height / h);
            console.log('scale: ' + scale);

            w = Math.round(w * scale);
            h = Math.round(h * scale);
        }
        // console.log("w + h : " + w + ' + ' + h)

        let canvas = document.createElement('canvas');
        let ctx = canvas.getContext('2d');

        // 创建属性节点
        let anw = document.createAttribute('width');
        anw.nodeValue = w;
        let anh = document.createAttribute('height');
        anh.nodeValue = h;
        canvas.setAttributeNode(anw);
        canvas.setAttributeNode(anh);
        ctx.drawImage(img, 0, 0, w, h);

        let ndata = canvas.toDataURL('image/jpeg', zoom);
        // console.log(ndata)
        // console.log('*******压缩后的图片大小*******')
        // console.log(ndata.length / 1024)

        return ndata;
    },
    turnImg(turn, zoom=0.8, width=400, height=400) {
        // 初始化
        turn.turns = turn.turns + 1;

        let that = turn.image;
        let w = that.width
        let h = that.height
        // console.log("w + h : " + w + ' + ' + h)

        if ((width != 0 && w > width) || (height != 0 && h > height)) {
            let scale = Math.min(width / w, height / h);
            console.log('scale: ' + scale);

            w = Math.round(w * scale);
            h = Math.round(h * scale);
        }
        // console.log("w + h : " + w + ' + ' + h)

        let canvas = document.createElement('canvas');
        let ctx = canvas.getContext('2d');

        // 创建属性节点
        let anw = document.createAttribute('width');
        anw.nodeValue = w;
        let anh = document.createAttribute('height');
        anh.nodeValue = h;
        canvas.setAttributeNode(anw);
        canvas.setAttributeNode(anh);
        // ctx.drawImage(that, 0, 0, w, h)

        console.log("w + h : " + w + ' + ' + h);

        // 为1，正常
        switch (turn.turns % 4) {
            case 1: // 需要顺时针（向左）90度旋转
                ctx.rotate(90 * Math.PI / 180);
                ctx.drawImage(that, 0, 0, h, -w);
                break;
            case 2: // 需要180度旋转
                ctx.rotate(180 * Math.PI / 180);
                ctx.drawImage(that, -w, -h, w, h);
                break;
            case 3: // 需要逆时针（向右）90度旋转
                ctx.rotate(270 * Math.PI / 180);
                ctx.drawImage(that, -h, 0, h, w);
                break;
            default:
                ctx.drawImage(that, 0, 0, w, h);
                break;
        }

        let ndata = canvas.toDataURL('image/jpeg', zoom);
        // console.log('*******旋转后的图片大小*******')
        // console.log(ndata.length / 1024)

        return ndata;
    }
};
